import $api from '../API'

export interface PasskeyMetadata {
  id: string
  credential_id: string
  user_id: string
  device_name: string
  device_type?: string | null
  browser?: string | null
  operating_system?: string | null
  is_synced?: boolean | null
  sync_provider?: string | null
  authenticator_attachment?: string | null
  user_agent?: string | null
  ip_address?: string | null
  platform?: string | null
  screen_resolution?: string | null
  timezone?: string | null
  language?: string | null
  last_used?: string | null
  created_at: string
  updated_at: string
}

export interface PasskeyUpsertPayload {
  credentialId: string
  deviceName: string
  browser?: string
  operatingSystem?: string
  deviceType?: string
  isSynced?: boolean
  syncProvider?: string
  authenticatorAttachment?: string
  platform?: string
  screenResolution?: string
  timezone?: string
  language?: string
}

class PasskeyMetadataService {
  static async upsert(payload: PasskeyUpsertPayload): Promise<PasskeyMetadata> {
    const { data } = await $api.post<{ metadata: PasskeyMetadata }>('/passkeys/metadata', payload)
    return data.metadata
  }

  static async getAll(): Promise<PasskeyMetadata[]> {
    const { data } = await $api.get<{ metadata: PasskeyMetadata[] }>('/passkeys/metadata')
    return data.metadata
  }

  static async updateDeviceName(
    credentialId: string,
    deviceName: string
  ): Promise<PasskeyMetadata> {
    const { data } = await $api.put<{ metadata: PasskeyMetadata }>(
      `/passkeys/metadata/${encodeURIComponent(credentialId)}`,
      { deviceName }
    )
    return data.metadata
  }

  static async delete(credentialId: string): Promise<void> {
    await $api.delete(`/passkeys/metadata/${encodeURIComponent(credentialId)}`)
  }

  static async updateLastUsed(credentialId: string): Promise<PasskeyMetadata> {
    const { data } = await $api.post<{ metadata: PasskeyMetadata }>(
      `/passkeys/metadata/${encodeURIComponent(credentialId)}/used`
    )
    return data.metadata
  }

  static async cleanupOrphaned(activeCredentialIds: string[]): Promise<number> {
    const { data } = await $api.post<{ deleted: number }>(`/passkeys/metadata/cleanup`, {
      activeCredentialIds
    })
    return data.deleted
  }
}

export default PasskeyMetadataService
